import React from "react";

import { valueToString } from "helpers/Helpers";
import classNames from "classnames";

import BaseReportTable from "./BaseReportTable";
import { ColumnInstance } from "react-table";

import "components/reportTable/reportTable.scss";
import { formatReportCurrency } from "helpers/reportFormat";

interface IProps {
  data: Array<Record<string, any>>;
  columns: Array<Record<string, any>>;
  description: string;
  compileDate: string;
  setFilteredColumns?: (columns: Array<ColumnInstance<Record<string, any>>>) => void;
  toolbarActions?: React.ReactNode;
}

export default function RoundsByCustomerTypeTable(props: IProps) {
  function formatDisplay(type: string, value: string) {
    let newValue = value !== null && value !== undefined ? value : "";

    if (!isNaN(Number(newValue)) && newValue !== "") {
      switch (type) {
        case "currency":
          newValue = formatReportCurrency(value);
          break;
        case "decimal":
          newValue = Number(value).toFixed(2);
          break;
        case "percentage":
          newValue = `${Number(value) * 100}%`;
          break;
        default:
          break;
      }
    } else if (type === "string" && newValue !== "") {
      newValue = valueToString(value).replace(/(^\w|\s\w)/g, c => c.toUpperCase());
    }

    return newValue;
  }

  // Format cell data based on column
  function cellData(columnId: string, cellValue: string, displayType: string) {
    return formatDisplay(displayType, cellValue);
  }

  // Add on click events based on column
  function cellOnClick() {
    return {};
  }

  function cellClassNames(cell: any, isRowLocked: boolean) {
    return classNames({
      "report-table-row-locked": isRowLocked,
    });
  }

  // Add footer data based on column
  function footerData(columnId: string) {
    switch (columnId) {
      case "date":
        return null;
      default:
        return getTotal(columnId, "number");
    }
  }

  function getTotal(columnId: string, type: string): number | string {
    let total = 0;
    props.data.forEach(row => {
      if (row[columnId]) {
        total += Number(row[columnId]);
      }
    });
    if (type === "currency") {
      return formatReportCurrency(total);
    } else {
      return total;
    }
  }

  return (
    <BaseReportTable
      data={props.data}
      columns={props.columns}
      description={props.description}
      compileDate={props.compileDate}
      cellOnClick={cellOnClick}
      cellData={cellData}
      cellClassNames={cellClassNames}
      footerData={footerData}
      expanding={false}
      setFilteredColumns={props.setFilteredColumns}
      toolbarActions={props.toolbarActions}
    />
  );
}
